<template>
  <div class="step-content">
    <div class="process">
      <div
        class="item"
        v-for="(item, index) in setpData"
        v-bind:key="item.step"
      >
        <div
          class="swap"
          :class="{ 'swap-active': item.isCompleted || item.isWorking }"
        >
          <span class="circular">
            <div class="circular-inner">{{ item.step }}</div>
          </span>
          <span class="text">{{ item.name }}</span>
        </div>
        <div
          v-if="!isLastItem(index)"
          class="process-line"
          :class="{
            'process-line-active': item.isCompleted,
            'process-line-completed': item.isWorking
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stepContent: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      temp: [
        {
          step: 1,
          name: '身份认证',
          isCompleted: true
        },
        {
          step: 2,
          name: '设置新密码',
          isCompleted: true
        },
        {
          step: 3,
          name: '完成',
          isCompleted: false,
          isWorking: false
        }
      ]
    }
  },
  computed: {
    setpData() {
      var res = this.stepContent
      for (var i = 0; i < res.length; i++) {
        if (i === 0) {
          if (!res[i].isCompleted) {
            res[i].isWorking = true
          }
        } else {
          res[i].isWorking = !res[i].isCompleted && res[i - 1].isCompleted
        }
      }
      return res
    }
  },
  methods: {
    isLastItem(i) {
      return i === this.stepContent.length - 1
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped>
.step-content {
  width: 600px;
  height: 100px;
  background-color: #ffffff;
  border-radius: 5px;
  display: flex;
  .item {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .process {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .swap {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 70px;
      .circular {
        width: 30px;
        height: 30px;
        border-radius: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 5px solid rgb(133, 133, 133, 0.1);
      }
      .circular-inner {
        opacity: 1;
        z-index: 10;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        border-radius: 30px;

        font-family: Arial-BoldMT;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 40px;
        letter-spacing: 0px;
      }
      .text {
        width: 100%;
        height: 14px;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 40px;
        letter-spacing: 0px;
        color: #858585;
        text-align: center;
      }
    }
    .swap-active {
      .circular-inner {
        background-color: #046bcc;
        color: #ffffff;
      }
      .text {
        color: #046bcc;
      }
    }
    .process-line {
      width: 100px;
      height: 4px;
      background-color: #858585;
      border-radius: 2px;
      opacity: 0.15;
      margin-top: -15px;
    }
    .process-line-active,
    .process-line-completed {
      background-color: #046bcc;
      opacity: 0.8;
    }
    .process-line-completed {
      background-image: linear-gradient(90deg, #046bcc 0%, #f3f3f3 100%),
        linear-gradient(#858585, #858585);
      background-blend-mode: normal, normal;
    }
  }
}
</style>
